<nz-layout class="layout">
	<nz-sider nzCollapsible [(nzCollapsed)]="isCollapsed" [nzWidth]="width" [nzReverseArrow]="isReverseArrow"
		*ngIf="sidebarReady || Helpers.isGod()"
		class="!bg-gradient-to-r from-[#202d35] to-[#516876] dark:from-navy-700 dark:to-navy-700">
		<div class="sidebar-logo text-center">
			<a href="#" target="_blank">
				<img src="./assets/images/logo/{{ _brandIconName }}" alt="" class="logo m-auto mt-5" />
			</a>
		</div>
		<!-- @if(currentRoute !== 'home'){ -->
		<ul nz-menu nzMode="inline" nzTheme="dark" class="sidebar-menu">
			<!-- <li nz-submenu *ngIf="isSectionVisible(HiddenSectionsKonstants.CASHBACK)" [(nzOpen)]="openMap['sub3_1']" (nzOpenChange)="openHandler('sub3_1')" nzTitle="Cashback" nzIcon="ng-zorro:piggy_bank">
                <ul>
                    <li nz-menu-item>
                        <a routerLink="/cashback">cashback</a>
                    </li>
                </ul>
            </li> -->
			<li nz-submenu *ngIf="isSectionVisible(HiddenSectionsKonstants.ANALYTICS)" [(nzOpen)]="openMap['sub2']"
				(nzOpenChange)="openHandler('sub2', 'main')" nzTitle="Analytics" nzIcon="ng-zorro:analytics">
				<ul>
					<li nz-menu-item>
						<a routerLink="/analytics/overview">Overview</a>
					</li>
					@if (isSectionVisible(HiddenSectionsKonstants.REAL_TIME)) {
					<li nz-menu-item>
						<a routerLink="/analytics/realtime">Real-Time</a>
					</li>
					}
					<li nz-submenu nzTitle="Time Distribution" [(nzOpen)]="openMap['sub2_1']"
						(nzOpenChange)="openHandler('sub2_1', 'sub')">
						<ul>
							<li nz-menu-item>
								<a routerLink="/analytics/users">Users</a>
							</li>
							<li nz-menu-item>
								<a routerLink="/analytics/sessions">Sessions</a>
							</li>
							<li nz-menu-item>
								<a routerLink="/analytics/traffic">Traffic</a>
							</li>
						</ul>
					</li>
					<ul>
						<li nz-menu-item>
							<a routerLink="/analytics/trend">Trend</a>
						</li>
					</ul>
					<li *ngIf="_showMonitoring" nz-submenu nzTitle="Location" [(nzOpen)]="openMap2['sub2_2']"
						(nzOpenChange)="openHandler('sub2_2', 'sub')">
						<ul>
							<li nz-menu-item>
								<a routerLink="/analytics/ranking">Ranking</a>
							</li>
							<li nz-menu-item *ngIf="isSectionVisible(HiddenSectionsKonstants.MONITORING)">
								<a routerLink="/analytics/monitoring">Monitoring</a>
							</li>
						</ul>
					</li>
				</ul>
			</li>
			<li nz-submenu *ngIf="isSectionVisible(HiddenSectionsKonstants.REGISTERED_USER)" [(nzOpen)]="openMap['sub3']"
				(nzOpenChange)="openHandler('sub3', 'main')" nzTitle="Registered User" nzIcon="ng-zorro:users">
				<ul>
					<li nz-menu-item>
						<a routerLink="/identities">Identities</a>
					</li>
					<!-- <li nz-menu-item>
						<a routerLink="/segments">Segments</a>
					</li> -->
				</ul>
			</li>
			@if (Helpers.getRoleFromLS() == 'Editor') {
			<li nz-submenu *ngIf="isSectionVisible(HiddenSectionsKonstants.DASHBOARDD_ACCOUNT)" [(nzOpen)]="openMap['sub4']"
				(nzOpenChange)="openHandler('sub4', 'main')" nzTitle="Account" nzIcon="ng-zorro:setting">
				<ul>
					<li nz-menu-item>
						<a routerLink="/dashboard-accounts">Dashboard accounts</a>
					</li>
				</ul>
			</li>
			}
			<!-- @if(Helpers.isGod()){ -->
			@if (isSectionVisible(HiddenSectionsKonstants.PASSPOINT)) {
			<li nz-submenu [(nzOpen)]="openMap['sub6']" (nzOpenChange)="openHandler('sub6', 'main')" nzTitle="Profile Center"
				nzIcon="ng-zorro:envelope">
				<ul>
					<li nz-menu-item>
						<a routerLink="/invitation">Invitations</a>
					</li>
				</ul>
			</li>
			}

			<!-- @if(Helpers.isGod()){ -->
			@if (isSectionVisible(HiddenSectionsKonstants.TROUBLESHOOTING)) {
			<li nz-submenu [(nzOpen)]="openMap['sub7']" (nzOpenChange)="openHandler('sub7', 'main')" nzTitle="Troubleshooting"
				nzIcon="ng-zorro:troubleshooting">
				<ul>
					<li nz-menu-item>
						<a routerLink="/troubleshooting/sessions">Sessions</a>
					</li>
					<li nz-menu-item>
						<a routerLink="/troubleshooting/logs">Logs</a>
					</li>
					<!-- <li nz-menu-item>
							<a routerLink="/troubleshooting/events">Event Stat</a>
						</li> -->
				</ul>
			</li>
			}
			<li *ngIf="Helpers.isGod()" nz-submenu [(nzOpen)]="openMap['sub5']" (nzOpenChange)="openHandler('sub5', 'main')"
				nzTitle="Management" nzIcon="ng-zorro:setting">
				<ul>
					<li nz-menu-item>
						<a routerLink="/dashboard-accounts">Dashboard accounts</a>
					</li>
					<li nz-menu-item>
						<a routerLink="/location-group">Location Group</a>
					</li>
					<li nz-menu-item>
						<a routerLink="/god-list">God</a>
					</li>
				</ul>
			</li>



		</ul>
		<!-- } -->
		<div class="sidebar-bottom-button text-center mt-auto" style="position: absolute; bottom: 20px; width: 100%">
			<div nz-row>
				<div class="text-left w-full ml-3">
					<div>
						<button nz-button nz-dropdown [nzDropdownMenu]="menu" style="
								width: 10px;
								background: transparent;
								border: transparent;
								padding-left: 0px;
								padding-top: 0px;
							">
							<svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="
									width: 40px;
									border-radius: 30px;
									padding: 4px;
									border: 1px solid #fff;
								">
								<path style="fill: #fff"
									d="M12,12.5A5.5,5.5,0,1,0,6.5,7,5.50654,5.50654,0,0,0,12,12.5Zm0-10A4.5,4.5,0,1,1,7.5,7,4.50491,4.50491,0,0,1,12,2.5Zm-5,13H17A4.50491,4.50491,0,0,1,21.5,20v2a.5.5,0,0,1-1,0V20A3.50424,3.50424,0,0,0,17,16.5H7A3.50424,3.50424,0,0,0,3.5,20v2a.5.5,0,0,1-1,0V20A4.50491,4.50491,0,0,1,7,15.5Z"
									fill="#ffffff" />
							</svg>
						</button>
					</div>
				</div>
			</div>
		</div>
	</nz-sider>
	<nz-layout class="dark:bg-navy-600">
		<nz-content>
			<div class="flex float-right z-[51] absolute right-16">
				<div class="m-5 text-right font-poppins_light dark:text-navy-100">
					<div class="grid grid-rows-2">
						<!-- @if (_periodToShow) {
						<div>
							<span class="font-poppins_bold text-sky-800 dark:text-accent-light/80">{{ 'header.period' |
								translate }}:
							</span>
							<span class="font-poppins_light text-sky-800 dark:text-accent-light/80">{{ _periodToShow }}</span>
						</div>
						} -->
						@if (listLocationsGroups.length > 1) {
						<div>
							<span class="font-poppins_bold text-sky-800 dark:text-accent-light/80">{{ 'header.locationGroup' |
								translate }}:
							</span>
							<span class="font-poppins_light text-sky-800 dark:text-accent-light/80">{{ _locationGroupName }}</span>
						</div>
						}
						@if (Helpers.getRole() !== 'User') {
						<div>
							@if (_locationName !== '') {
							<span class="font-poppins_bold text-sky-800 dark:text-accent-light/80">{{ 'header.locationId' | translate
								}}:
							</span>
							<span class="font-poppins_light text-sky-800 dark:text-accent-light/80">{{ _locationName }}</span>
							} @else {
							<span class="font-poppins_bold text-sky-800 dark:text-accent-light/80">{{ 'header.locationId' | translate
								}}:
							</span>
							<span class="font-poppins_light text-sky-800 dark:text-accent-light/80">
								{{ 'header.allLocations' | translate }}</span>
							}
						</div>
						}
					</div>
				</div>
				<div class="my-5 mx-2 rounded-[6px] px-[14px] pt-2 pb-[1px] bg-white">
					<dashboard-language-selector></dashboard-language-selector>
				</div>
				<div class="my-5 mx-2 rounded-[6px] pr-[9px] pl-[13px] pt-[7px] pb-[1px] bg-white">
					<button (click)="changeDarkMode()"
						class="darkmode-toggle btn h-8 w-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
						<svg *ngIf="themeSwitcher; else moonIcon" class="darkmode-sun h-6 w-6 text-black" viewBox="0 0 20 20"
							fill="currentColor">
							<path fill-rule="evenodd"
								d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
								clip-rule="evenodd" />
						</svg>
						<ng-template #moonIcon>
							<svg class="darkmode-moon h-6 w-6 text-black" fill="currentColor" viewBox="0 0 24 24">
								<path
									d="M11.75 3.412a.818.818 0 01-.07.917 6.332 6.332 0 00-1.4 3.971c0 3.564 2.98 6.494 6.706 6.494a6.86 6.86 0 002.856-.617.818.818 0 011.1 1.047C19.593 18.614 16.218 21 12.283 21 7.18 21 3 16.973 3 11.956c0-4.563 3.46-8.31 7.925-8.948a.818.818 0 01.826.404z" />
							</svg>
						</ng-template>
					</button>
				</div>
				<div class="my-5 mx-2 rounded-[6px] pr-[9px] pl-[9px] pt-[5px] pb-[1px] bg-white">
					<button nz-button nzType="primary" (click)="open()" class="filter-button">
						<svg width="28px" height="28px" viewBox="-0.5 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
							<path
								d="M22 3.58002H2C1.99912 5.28492 2.43416 6.96173 3.26376 8.45117C4.09337 9.94062 5.29 11.1932 6.73999 12.09C7.44033 12.5379 8.01525 13.1565 8.41062 13.8877C8.80598 14.6189 9.00879 15.4388 9 16.27V21.54L15 20.54V16.25C14.9912 15.4188 15.194 14.599 15.5894 13.8677C15.9847 13.1365 16.5597 12.5178 17.26 12.07C18.7071 11.175 19.9019 9.92554 20.7314 8.43988C21.5608 6.95422 21.9975 5.28153 22 3.58002Z"
								stroke="#000000" stroke-width="1.0" stroke-linecap="round" stroke-linejoin="round" />
						</svg>
					</button>
				</div>
			</div>
			<router-outlet></router-outlet>
		</nz-content>
		<nz-footer class="text-center dark:bg-navy-700 dark:text-navy-100">
			<app-version></app-version>
		</nz-footer>
	</nz-layout>
</nz-layout>

<nz-dropdown-menu #menu="nzDropdownMenu">
	<ul nz-menu class="text-right">
		<li nz-menu-item>
			<a (click)="logout()" nzType="primary"><i nz-icon nzType="logout" nzTheme="outline"></i> Logout</a>
		</li>
	</ul>
</nz-dropdown-menu>

<nz-drawer [nzClosable]="false" [nzVisible]="_drawerVisible" nzPlacement="right" nzTitle="Settings"
	(nzOnClose)="close()" [nzFooter]="footerTpl">
	<ng-container *nzDrawerContent>
		<!-- @if(_showSelects){ -->
		<div nz-row *ngIf="_showSelects">
			<div nz-col nzSpan="24" class="my-3">
				<h3 class="text-[20px] font-poppins_light text-gray-600">Tenants</h3>
				<nz-select [(ngModel)]="_tenant" [nzSize]="size" nzShowSearch nzAllowClear
					[ngModelOptions]="{ standalone: true }" (ngModelChange)="changeTenantSelect($event)"
					[nzDisabled]="_tenantsList.length === 1">
					<nz-option *ngFor="let option of _tenantsList" [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
				</nz-select>
			</div>
		</div>
		<!-- Location Group section -->
		<div nz-row *ngIf="_showSelects">
			<div nz-col nzSpan="24" class="my-3">
				<h3 class="text-[20px] font-poppins_light text-gray-600">
					Location Group
				</h3>
				<nz-select [(ngModel)]="_locationGroup" [nzSize]="size" nzShowSearch nzAllowClear
					[ngModelOptions]="{ standalone: true }" (ngModelChange)="changeLocationGroupSelect($event)">
					<nz-option *ngFor="let option of listLocationsGroups" [nzLabel]="option.name"
						[nzValue]="option.id"></nz-option>
				</nz-select>
			</div>
		</div>
		<!-- Location ID section -->
		<div nz-row *ngIf="_showSelects">
			<div nz-col nzSpan="24" class="my-3">
				<h3 class="text-[20px] font-poppins_light text-gray-600">Location</h3>
				<nz-select [(ngModel)]="_locationID" [nzSize]="size" nzShowSearch nzAllowClear
					[ngModelOptions]="{ standalone: true }" (ngModelChange)="changeLocationIDSelect($event)">
					<nz-option *ngFor="let option of listLocationsID" [nzLabel]="option.name" [nzValue]="option.id"></nz-option>
				</nz-select>
			</div>
		</div>

		<!-- Pickerdata section -->
		@if (currentRoute !== 'trend') {
		<div nz-row>
			<div nz-col nzSpan="24" class="my-3">
				<h3 class="text-[20px] font-poppins_light text-gray-600">
					Data selector
				</h3>
				<nz-select [(ngModel)]="_timeRange" [nzSize]="size" nzShowSearch [ngModelOptions]="{ standalone: true }"
					[compareWith]="compareSelectValue" (ngModelChange)="changeTimeRangeSelect($event)"
					(keydown.enter)="saveFilterData()">
					<nz-option *ngFor="let tr of listTimeRange" [nzLabel]="tr.name | translate" [nzValue]="tr.value"></nz-option>
				</nz-select>
			</div>
		</div>
		<div nz-row>
			<div nz-col nzSpan="24" class="my-3">
				@if (_showWEEKSelect) {
				<nz-date-picker [nzMode]="mode" [(ngModel)]="selectedDate" (ngModelChange)="onDateChange($event)"
					[nzDisabledDate]="disabledDate"></nz-date-picker>
				}
			</div>
		</div>
		}
		<!-- Language section / Dark modode section-->
		<!-- <div nz-row>
            <div class="grid grid-cols-2 w-full">
                <div nz-col nzSpan="24" class="my-3">
                    <h3 class="text-[20px] font-poppins_light text-gray-600">Language</h3>
                    <dashboard-language-selector></dashboard-language-selector>
                </div>
                <div nz-col nzSpan="24" class="my-3">
                    <h3 class="text-[20px] font-poppins_light text-gray-600">Mode</h3><button (click)="changeDarkMode()"
                        class="darkmode-toggle btn h-8 w-8 rounded-full p-0 hover:bg-slate-300/20 focus:bg-slate-300/20 active:bg-slate-300/25 dark:hover:bg-navy-300/20 dark:focus:bg-navy-300/20 dark:active:bg-navy-300/25">
                        <svg *ngIf="themeSwitcher; else moonIcon" class="darkmode-sun h-6 w-6 text-black"
                            viewBox="0 0 20 20" fill="currentColor">
                            <path fill-rule="evenodd"
                                d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                clip-rule="evenodd" />
                        </svg>
                        <ng-template #moonIcon>
                            <svg class="darkmode-moon h-6 w-6 text-black" fill="currentColor" viewBox="0 0 24 24">
                                <path
                                    d="M11.75 3.412a.818.818 0 01-.07.917 6.332 6.332 0 00-1.4 3.971c0 3.564 2.98 6.494 6.706 6.494a6.86 6.86 0 002.856-.617.818.818 0 011.1 1.047C19.593 18.614 16.218 21 12.283 21 7.18 21 3 16.973 3 11.956c0-4.563 3.46-8.31 7.925-8.948a.818.818 0 01.826.404z" />
                            </svg>
                        </ng-template>
                    </button>
                </div>

            </div>
        </div> -->
		<!-- Logout section -->
		<!-- <div nz-row>
            <div class="grid grid-cols-2 w-full">
                <div>
                    <h3 class="text-[20px] font-poppins_light text-gray-600">Logout</h3><button nz-button nz-dropdown
                        [nzDropdownMenu]="menu" nzPlacement="bottomRight"
                        style="width: 10px;background: transparent;border: transparent;padding-left: 0px;padding-top: 0px;">
                        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"
                            style="width: 40px;background: white;border-radius: 10px;padding: 4px;">
                            <path style="fill: #364853;"
                                d="M12,12.5A5.5,5.5,0,1,0,6.5,7,5.50654,5.50654,0,0,0,12,12.5Zm0-10A4.5,4.5,0,1,1,7.5,7,4.50491,4.50491,0,0,1,12,2.5Zm-5,13H17A4.50491,4.50491,0,0,1,21.5,20v2a.5.5,0,0,1-1,0V20A3.50424,3.50424,0,0,0,17,16.5H7A3.50424,3.50424,0,0,0,3.5,20v2a.5.5,0,0,1-1,0V20A4.50491,4.50491,0,0,1,7,15.5Z"
                                fill="#ffffff" />
                        </svg>
                    </button>
                </div>
            </div>
        </div> -->
	</ng-container>
	<ng-template #footerTpl>
		<div style="float: left">
			<button nz-button n style="margin-right: 8px" (click)="oldVersion()">
				{{ 'modal.v_old_dashboard_button' | translate }}
			</button>
		</div>
		<div style="float: right">
			<button nz-button style="margin-right: 8px" (click)="close()">
				Close
			</button>
			<button nz-button nzType="primary" (click)="saveFilterData()">
				Save
			</button>
		</div>
	</ng-template>
</nz-drawer>

@let modTitle = 'modal.v_old_dashboard_title' | translate;
<nz-modal [(nzVisible)]="_isVisible" nzTitle="{{ modTitle }}" (nzOnCancel)="handleCancel()" (nzOnOk)="handleOk()">
	<ng-container *nzModalContent>
		<nz-row class="text-center">
			<nz-col nzSpan="24">
				<span [innerHTML]="'modal.v_old_dashboard_text' | translate"></span>
			</nz-col>
		</nz-row>
	</ng-container>
</nz-modal>